import '../styles/App.css'

function Header() {
    return (
        <div className={'head'}>
            <div id={'logo'}>
                <div id={'terra'}>TERRA</div>
                <div id={'bakW'}>
                    <div className={'line'}>d</div>
                    <div id={'bak'}>bar & kitchen</div>
                    <div className={'line'}>d</div>
                </div>
            </div>
        </div>
    )
}

export default Header